import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'sbnb-thermostat-setup-success-done',
  templateUrl: './thermostat-setup-success-done.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThermostatSetupSuccessDoneComponent {
  @HostBinding('class') class = 'contents';

  onAdvancedSettings() {
    window.open('https://help.hospitable.com/en/articles/10231453-how-thermostat-presets-work', '_blank');
  }
}
